export const authTranslations = {
  en: {
    login: {
      title: 'Welcome back',
      subtitle: 'Sign in to continue your journey with innovative solutions',
      welcomeBack: 'Welcome Back',
      noAccount: 'Don\'t have an account?',
      signUp: 'sign up here',
      email: 'Email address',
      password: 'Password',
      signInButton: 'Sign In',
      signingIn: 'Signing in...',
      backToHome: '← Back to home',
      forgotPassword: 'Forgot your password?'
    },
    register: {
      title: 'Create account',
      subtitle: 'Join our team and start building amazing projects together',
      joinUs: 'Join Our Team',
      orText: 'Already have an account?',
      loginLink: 'sign in here',
      fullName: 'Full name',
      email: 'Email address',
      password: 'Password',
      confirmPassword: 'Confirm password',
      createAccount: 'Create account',
      creating: 'Creating...',
      backToHome: '← Back to home',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters long'
    },
    forgotPassword: {
      title: 'Reset Password',
      subtitle: 'Enter your email and we\'ll send you a link to reset your password',
      badge: 'Password Recovery',
      email: 'Email address',
      sendButton: 'Send Reset Link',
      sending: 'Sending...',
      backToLogin: '← Back to login',
      rememberedPassword: 'Remembered your password?',
      loginLink: 'sign in here'
    },
    resetPassword: {
      title: 'Set New Password',
      subtitle: 'Create a strong password for your account',
      badge: 'New Password',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      resetButton: 'Reset Password',
      resetting: 'Resetting...',
      backToLogin: '← Back to login'
    },
    common: {
      email: 'Email',
      password: 'Password',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      or: 'or',
      continueWith: 'Continue with',
      rememberMe: 'Remember me'
    },
    oauth: {
      google: 'Continue with Google',
      github: 'Continue with GitHub',
      divider: 'or continue with email'
    },
    messages: {
      registerSuccess: '🎉 Account created successfully!',
      registerSuccessDesc: 'Please check your email to confirm your account.',
      registerError: '❌ Registration failed',
      loginError: '❌ Login failed',
      loginErrorDesc: 'Please check your credentials and try again.',
      emailNotConfirmed: '📧 Email not confirmed',
      emailNotConfirmedDesc: 'Please check your inbox and confirm your email address before logging in.',
      emailConfirmed: '✅ Email Confirmed!',
      emailConfirmedDesc: 'Your email has been verified. You can now log in to your account.',
      unexpectedError: 'An unexpected error occurred. Please try again.',
      resetEmailSent: '📧 Reset link sent!',
      resetEmailSentDesc: 'Check your email for a link to reset your password. It may take a few minutes to arrive.',
      resetError: '❌ Failed to send reset link',
      resetErrorDesc: 'Please check your email address and try again.',
      passwordResetSuccess: '✅ Password updated!',
      passwordResetSuccessDesc: 'Your password has been successfully changed. You can now login with your new password.',
      passwordResetError: '❌ Failed to reset password',
      passwordResetErrorDesc: 'The reset link may have expired. Please request a new one.',
      resendSuccess: '📧 Confirmation email sent!',
      resendSuccessDesc: 'Please check your inbox for the confirmation link.',
      resendError: '❌ Failed to resend confirmation',
      resendErrorDesc: 'Please try again later.'
    }
  },
  uk: {
    login: {
      title: 'Ласкаво просимо назад',
      subtitle: 'Увійдіть, щоб продовжити свою подорож з інноваційними рішеннями',
      welcomeBack: 'Ласкаво просимо назад',
      noAccount: 'Немає акаунту?',
      signUp: 'зареєструйтеся тут',
      email: 'Email адреса',
      password: 'Пароль',
      signInButton: 'Увійти',
      signingIn: 'Входимо...',
      backToHome: '← Повернутися на головну',
      forgotPassword: 'Забули пароль?'
    },
    register: {
      title: 'Створити акаунт',
      subtitle: 'Приєднуйтеся до нашої команди та почніть будувати неймовірні проекти разом',
      joinUs: 'Приєднатися до команди',
      orText: 'Вже є акаунт?',
      loginLink: 'увійдіть тут',
      fullName: 'Повне ім\'я',
      email: 'Email адреса',
      password: 'Пароль',
      confirmPassword: 'Підтвердити пароль',
      createAccount: 'Створити акаунт',
      creating: 'Створюємо...',
      backToHome: '← Повернутися на головну',
      passwordMismatch: 'Паролі не співпадають',
      passwordTooShort: 'Пароль має бути не менше 6 символів'
    },
    forgotPassword: {
      title: 'Відновлення пароля',
      subtitle: 'Введіть свій email і ми надішлемо вам посилання для скидання пароля',
      badge: 'Відновлення пароля',
      email: 'Email адреса',
      sendButton: 'Надіслати посилання',
      sending: 'Надсилаємо...',
      backToLogin: '← Повернутися до входу',
      rememberedPassword: 'Згадали пароль?',
      loginLink: 'увійдіть тут'
    },
    resetPassword: {
      title: 'Новий пароль',
      subtitle: 'Створіть надійний пароль для вашого акаунту',
      badge: 'Новий пароль',
      newPassword: 'Новий пароль',
      confirmPassword: 'Підтвердити новий пароль',
      resetButton: 'Змінити пароль',
      resetting: 'Змінюємо...',
      backToLogin: '← Повернутися до входу'
    },
    common: {
      email: 'Email',
      password: 'Пароль',
      loading: 'Завантаження...',
      error: 'Помилка',
      success: 'Успіх',
      or: 'або',
      continueWith: 'Продовжити з',
      rememberMe: 'Запам\'ятати мене'
    },
    oauth: {
      google: 'Продовжити з Google',
      github: 'Продовжити з GitHub',
      divider: 'або продовжити з email'
    },
    messages: {
      registerSuccess: '🎉 Акаунт успішно створено!',
      registerSuccessDesc: 'Будь ласка, перевірте свою електронну пошту для підтвердження акаунту.',
      registerError: '❌ Реєстрація не вдалася',
      loginError: '❌ Вхід не вдався',
      loginErrorDesc: 'Будь ласка, перевірте свої дані та спробуйте ще раз.',
      emailNotConfirmed: '📧 Email не підтверджено',
      emailNotConfirmedDesc: 'Будь ласка, перевірте вашу поштову скриньку та підтвердіть email адресу перед входом.',
      emailConfirmed: '✅ Email підтверджено!',
      emailConfirmedDesc: 'Ваш email підтверджено. Тепер ви можете увійти до свого акаунту.',
      unexpectedError: 'Виникла неочікувана помилка. Будь ласка, спробуйте ще раз.',
      resetEmailSent: '📧 Посилання надіслано!',
      resetEmailSentDesc: 'Перевірте свою електронну пошту для посилання на скидання пароля. Це може зайняти кілька хвилин.',
      resetError: '❌ Не вдалося надіслати посилання',
      resetErrorDesc: 'Будь ласка, перевірте email адресу та спробуйте ще раз.',
      passwordResetSuccess: '✅ Пароль оновлено!',
      passwordResetSuccessDesc: 'Ваш пароль успішно змінено. Тепер ви можете увійти з новим паролем.',
      passwordResetError: '❌ Не вдалося змінити пароль',
      passwordResetErrorDesc: 'Посилання могло застаріти. Будь ласка, запросіть нове.',
      resendSuccess: '📧 Лист підтвердження надіслано!',
      resendSuccessDesc: 'Будь ласка, перевірте вашу поштову скриньку.',
      resendError: '❌ Не вдалося надіслати лист',
      resendErrorDesc: 'Будь ласка, спробуйте пізніше.'
    }
  }
};